<template>
    <header class="public-header w-100">
        <nav>
            <div class="container">
                <div class="row text-white">
                    <div class="col">
                        <router-link class="navbar-brand" to="/login">
                            <img src="@/sass-template/content/images/casedrive-logo-white.svg" alt="casedrive-logo">
                        </router-link>
                    </div>
                    <div class="col text-end d-none d-md-inline moto">
                        <p class="mb-0 pt-2">Create. Organize. Share. Discuss. <br>Securely, on your own terms.</p>
                    </div>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
